import { render, staticRenderFns } from "./overlay.vue?vue&type=template&id=5f8e28ea&scoped=true&"
import script from "./overlay.vue?vue&type=script&lang=ts&"
export * from "./overlay.vue?vue&type=script&lang=ts&"
import style0 from "./overlay.vue?vue&type=style&index=0&id=5f8e28ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e28ea",
  null
  
)

export default component.exports